import React from 'react';
import PropTypes from 'prop-types';

export default class LinkComponent extends React.Component {

    static propTypes = {
        href: PropTypes.string,     // "http://gd.link"
        rel: PropTypes.string,      // "noreferrer noopener"
        target: PropTypes.string,   // "_self"
    }

    render() {
        const re = new RegExp("((?:https?:\\/\\/([^\\s]+(?:[^\\)| ]))))( )?(?:[\'\"]([\\s\\S]+?)[\'\"])?", 'gmi');
        const matchArr = re.exec(this.props.href);

        const linkArr = matchArr ? matchArr[2].split('/') : [];
        const isInternal = linkArr.shift() === 'gd-link';

        if (isInternal){
            const internalRef = linkArr.join('/');
            return (
                <a role="button" className="gd-rich-editor-tooltip-entity" onClick={(e)=>{
                    e.stopPropagation();
                    gd.goTo(internalRef);
                }}>
                    <span className="gd-rich-editor-tooltip-entity__text">{this.props.children}</span>
                </a>
            );
        } else {
            return (
                <a role="button" className="gd-rich-editor-tooltip-entity" href={this.props.href} target="_blank" >
                    <span className="gd-rich-editor-tooltip-entity__text">{this.props.children}</span>
                </a>
            );
        }
    }
}